import { AddressTypes, IAddress } from './address'
import { formatString } from '@cbgms/base/utils/helpers'

export const formatAddressHouseNumberThenStreet = (address: Partial<IAddress>, type: AddressTypes) => {
  if (type === 'Visitor') {
    return formatString(
      `${address.VisitorHouseNumber}${address.VisitorHouseNumberAddition}`,
      address.VisitorAddress,
      address.VisitorAddressExtra
    )
  }
  return formatString(`${address.PostalHouseNumber}${address.PostalHouseNumberAddition}`, address.PostalAddress, address.PostalAddressExtra)
}
